import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";

export default function LoadingDetailsSpinner() {
  return (
    <div className="absolute bottom-0 left-0 z-10 bg-gray-800 rounded-tr-lg p-2">
      <LoadingSpinner variant="none" size="sm" className="text-white" />
    </div>
  );
}
